module.exports = __webpack_public_path__ + "static/img/partIcon06.126d266e.png";